import { render, staticRenderFns } from "./resume-personal-information.vue?vue&type=template&id=6a2ab033"
import script from "./resume-personal-information.vue?vue&type=script&lang=js"
export * from "./resume-personal-information.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports